import { Controller } from '@hotwired/stimulus'
import { dispatcher } from './pub_controller'
import { formatCurrency, parseCurrency } from './utils/currency_utils'

export class InvoiceFormController extends Controller {
  static targets = ['serviceOfferingIds', 'totalAmount']
  declare readonly serviceOfferingIdsTarget: HTMLInputElement
  declare readonly totalAmountTarget: HTMLElement

  private variances: Map<
    string,
    {
      billed_amount: string
      variance_reason: string
      variance_comments: string
    }
  > = new Map()

  handleVarianceSubmit(event: CustomEvent) {
    var {
      service_offering_id,
      billed_amount,
      variance_reason,
      variance_comments,
    } = event.detail
    if (!service_offering_id) return

    this.variances.set(service_offering_id, {
      billed_amount,
      variance_reason,
      variance_comments,
    })

    let container = document.getElementById(
      `service_offering_${service_offering_id}`,
    )
    if (!container) {
      container = document.createElement('div')
      container.id = `service_offering_${service_offering_id}`
      this.element.appendChild(container)
    }

    // add hidden input fields
    const attributes = [
      { name: 'service_offering_id', value: service_offering_id },
      { name: 'billed_amount', value: billed_amount },
      { name: 'variance_reason', value: variance_reason },
      { name: 'variance_comments', value: variance_comments },
    ]
    attributes.forEach((attr) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = `invoice[invoice_service_offerings_attributes][][${attr.name}]`
      input.value = attr.value
      container.appendChild(input)
    })

    this.reapplyAllVariances()
  }

  reapplyAllVariances() {
    this.variances.forEach((variance, service_offering_id) => {
      const formattedAmount = formatCurrency(variance.billed_amount)

      dispatcher(this, 'update', 'transfer-row', {
        id: service_offering_id,
        updates: {
          billed_amount: formattedAmount,
          variance_reason: variance.variance_reason,
          variance_comments: variance.variance_comments,
        },
      })
    })

    this.updateTotalAmount()
  }

  updateTotalAmount() {
    setTimeout(() => {
      const selectTableBilledAmounts = Array.from(
        document.querySelectorAll(
          '.ant-transfer-list:last-of-type .transfer-editable-cell span:not(.anticon)',
        ),
      ).map((span) => {
        const value = span.textContent || '0'
        return parseCurrency(value)
      })

      const total = selectTableBilledAmounts.reduce(
        (sum, amount) => sum + amount,
        0,
      )
      this.totalAmountTarget.textContent = formatCurrency(total.toString())
    }, 50)
  }
}
